import React from 'react';

import { withSavedReports } from './../../../shared/containers/containerSavedReports'

import Notification from '../../../shared/items/static/notification'

import { states } from './../../../reducers/queriesStates'

const SavedReportsNotification = (props) => {
  const { savedReportsDataState, savedReportsData } = props

  return (
    savedReportsDataState === states.READY && savedReportsData.length <= 0
      ? <Notification type="warning">
        <p>Скаченные отчеты отсутствуют</p>
      </Notification>
      : savedReportsDataState === states.FAILURE
        ? <Notification type="error">
          <p>Ошибка запроса сохраненных отчетов</p>
        </Notification>
        : null
  )
}

export default withSavedReports(React.memo(SavedReportsNotification))